import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material';
import {SidebarNavEvent} from '../../config/events/sidebarNav.event';
import {Router} from '@angular/router';
import * as Constants from '../../config/constants';


// Observable class extensions


// Observable operators





import {AdminService} from '../../components/admin/services/admin.service';
import {UserData} from '../../config/globals/userData.global';
import {MaklerPaket} from "./service/Model/MaklerPaket";
import {transition} from "@angular/animations";
import {AppRoutingModule} from "../../app-routing.module";

@Component({
  selector: 'app-index',
  templateUrl: './app.index.component.html',
  styleUrls: ['./app.index.component.scss'],
})
export class AppIndexComponent implements OnInit {

  public showSidebarNav:boolean;
  public showAdminSidebarNav:boolean;
  public isKraft : boolean = false;
  public application : any;
  constructor(private _iconRegistry:MatIconRegistry,
              private _domSanitizer:DomSanitizer,
              private adminService:AdminService,
              private userData:UserData,
              private sidebarNavEvent:SidebarNavEvent,
              private router:Router) {
    this.showSidebarNav = false;
    this.showAdminSidebarNav = false;

    this._iconRegistry.addSvgIconInNamespace('assets', 'allianz_logo',
      this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/allianz_logo.svg'));
  }

  ngOnInit():void {
    //debugger;
    let bensl = this.userData.getBensl();
    console.log("Bensl: " + bensl);
    this.application = this.userData.isKraft();
    console.log("ngInit AppIndexComponent");
    console.log("isKraft = " + this.isKraft);
    if (this.application.indexOf("meinkonto")>-1) {
      console.log("not kraft");
      this.router.navigate(['/meinkonto']);

    }
    else if(this.application.indexOf("kraft")>-1){
      console.log("kraft");
      this.router.navigate(['/index-kraft']);
    }
    else if(this.application.indexOf("portal")>-1){

    }
    else if(this.application.indexOf("sach")>-1){
      this.router.navigate(['/index']);
    }

    this.sidebarNavEvent.sidebarNavEventEmit.subscribe(
      (flag:boolean) => {
        setTimeout((_:number) => this.showSidebarNav = flag);
      });
  }



  getVersion():string {
    return Constants.version;
  }


}
